import { Helmet } from 'react-helmet-async'
import { getTenantAssets } from '../../utils/tenantHelper'

const Head = () => {
  const { displayName, manifestUrl, favIconUrl } = getTenantAssets();
  return (
    <Helmet>
      <link rel="manifest" href={manifestUrl} fetchPriority='high' />
      <title>{displayName}</title>
      <link rel="icon" href={favIconUrl} type="image/png" />

    </Helmet>
  )
}

export default Head
